import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './ProductCard.css';

const Stars = ({ rating }) => (
  <span className="stars">
    {[1, 2, 3, 4, 5].map((i) => (
      <span key={i} className={`star ${i <= Math.round(rating) ? 'star-filled' : 'star-empty'}`}>
        ★
      </span>
    ))}
  </span>
);

const ProductCard = ({ product, delay = 0 }) => {
  const { addItem } = useCart();
  const [wishlist, setWishlist] = useState(false);
  const [adding, setAdding] = useState(false);

  // Support both old static shape and new API shape
  const price     = product.price      != null ? product.price     : parseFloat(product.discount_price ?? 0);
  const origPrice = product.originalPrice != null ? product.originalPrice : parseFloat(product.base_price ?? price);
  const name      = product.name   || product.title || '';
  const images    = product.images || (product.product_images || []).map((i) => i.image_url);
  const variants  = product.variants || (product.product_variants || []).map((v) => v.variant_value);
  const rating    = product.rating ?? 4.5;
  const reviews   = product.reviews ?? 0;
  const isFeatured  = product.isFeatured  ?? Boolean(product.is_featured);
  const isNew       = product.isNewArrival ?? Boolean(product.is_new_arrival);

  const discount =
    product.discount != null
      ? product.discount
      : origPrice > price
      ? Math.round(((origPrice - price) / origPrice) * 100)
      : 0;

  const productVariants = product.product_variants || [];
  // Sold out when every variant is out of stock. Falls back to the
  // top-level inStock flag for products that don't carry variants.
  const isSoldOut = productVariants.length
    ? productVariants.every((v) => Boolean(v.is_out_of_stock))
    : product.inStock === true;

  const tag = isSoldOut
    ? 'Sold Out'
    : isFeatured
    ? 'Best Seller'
    : isNew
    ? 'New Arrivals'
    : null;

  const tagClass = isSoldOut
    ? 'tag-soldout'
    : isFeatured
    ? 'tag-amber'
    : isNew
    ? 'tag-green'
    : 'tag-default';

  const handleAddToCart = (e) => {
    e.preventDefault();
    if (isSoldOut) return;
    setAdding(true);
    addItem(product, variants[0] || 'Default');
    setTimeout(() => setAdding(false), 1000);
  };

  return (
    <div
      className={`product-card ${isSoldOut ? 'product-card--soldout' : ''}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <Link to={`/products/${product.id}`} className="product-card__img-wrap">
        <img
          src={images[0] || 'https://images.unsplash.com/photo-1549007994-cb92caebd54b?w=600&q=80'}
          alt={name}
          className="product-card__img"
          loading="lazy"
        />
        {tag && (
          <span className={`product-card__tag ${tagClass}`}>{tag}</span>
        )}
        {discount > 0 && (
          <span className="product-card__discount">-{discount}%</span>
        )}

        {/* <button
          className={`product-card__wishlist ${wishlist ? 'wishlisted' : ''}`}
          onClick={(e) => { e.preventDefault(); setWishlist(!wishlist); }}
          aria-label="Wishlist"
        >
          {wishlist ? '♥' : '♡'}
        </button> */}

        <div className="product-card__overlay">
          <button
            className="product-card__quick-add btn btn-primary btn-sm"
            onClick={handleAddToCart}
            disabled={isSoldOut}
          >
            {isSoldOut ? 'Sold Out' : adding ? '✓ Added!' : '+ Add to Cart'}
          </button>
        </div>
      </Link>

      <div className="product-card__body">
        <div className="product-card__meta">
          <Stars rating={rating} />
          <span className="product-card__reviews">({reviews})</span>
        </div>
        <Link to={`/products/${product.id}`}>
          <h3 className="product-card__name">{name}</h3>
        </Link>
        <div className="product-card__price">
          <span className="product-card__price-current">₹{Number(price).toLocaleString('en-IN')}</span>
          {origPrice > price && (
            <span className="product-card__price-original">₹{Number(origPrice).toLocaleString('en-IN')}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;